import * as t from "io-ts";

export const Tier = t.union([
  t.literal("base_rate"),
  t.literal("enterprise_rate"),
]);

export type Tier = "base_rate" | "enterprise_rate";
